module.exports = __webpack_public_path__ + "static/img/welfare_banner.71f0186.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/welfare_banner.jpg
// module id = a91b
// module chunks = 0